
<div class="nav-div"  [ngStyle]="{'height':isLoginButtonDisabled ? '125px': '139px' }"
fxFlex=100 fxLayout="column wrap">
    
    <div class="logo-div" fxFlex="30" fxLayout="row wrap" fxLayoutAlign="start center">

        <span class="cinejoy_logo" ><a href="/cinejoy">cinejoy</a></span>
        <span class="creatics_logo"><a href="/">by CREATICS</a></span>

    </div>
  
    <div class="list-div" [ngStyle]="{'margin-top': isLoginButtonDisabled ? '1%': '2.09%' }" 
     fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="end center"
    >
        <span><a class="list" href="/cinejoy/about">ABOUT</a></span>
        <span><a class="list" href="/cinejoy/premiere/lineup">SPOTLIGHTS</a></span>
        <span><a class="list" href="/cinejoy/showcase/">SHOWCASE</a></span>
        <span><a class="list" href="/cinejoy/passport/community">PASSPORTS</a></span>
        <span><a class="list" style="text-transform: uppercase;" href="/cinejoy/screening-parties">Meetups</a></span>

    </div>
    <div class="signup-div" *ngIf ='isLoginButtonDisabled' 
    [ngStyle]="{'margin-top': isLoginButtonDisabled ? '2%': '0%' }"   fxLayout="row" fxLayoutAlign="end end">
        <span><a href="/signup">JOIN FREE /</a></span> 
        <span><a href="/login">&nbsp;LOGIN</a></span> 
    </div>
</div>
    

<div fxLayout="row wrap" class="mobile-navbar">
<div class="logo-div-mobile" fxLayoutAlign="center">
    <span class="cinejoy_logo" style="font-size: 36px;" ><a href="/cinejoy">cinejoy</a></span>
</div>

<div fxLayout="row" fxLayoutGap="20px" class="list-div-mobile"  [ngStyle]="{'margin-top':isLoginButtonDisabled ? '1%': '0%' }">
    <span><a href="/cinejoy/about">ABOUT</a></span>
        <span><a href="/cinejoy/premiere/lineup">SPOTLIGHTS</a></span>
        <span><a href="/cinejoy/showcase/">SHOWCASE</a></span>
        <span><a href="/cinejoy/passport/community">PASSPORTS</a></span>
        <span><a style="text-transform: uppercase;" href="/cinejoy/screening-parties">Meetups</a></span>
</div>

<div class="signup-div2" *ngIf="isLoginButtonDisabled" [ngClass]="isLoginButtonDisabled ? 'loginCheck' : '' "  fxLayout="row" fxLayoutAlign="end end">
    <span><a href="/signup">JOIN FREE /</a></span> 
    <span><a href="/login">&nbsp;LOGIN</a></span> 
</div>

</div>